import './Profile.css';
import React, { useEffect, useRef } from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';
import PasswordStrengthBar from 'react-password-strength-bar';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormHelperText from '@mui/material/FormHelperText';

import {
    ValidatePersonName,
    ValidatePassword,
} from '../../../libraries/Tool';

import {
    EditAccountInfor,
    UploadAvatar,
    GetAvatar,
    ChangePassword,
} from '../../../services/Profile.service';

function Profile(props) {
    const { translate, UserInfor, SnackbarAlert } = props;
    const [loading, setLoading] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [firstName, setFirstName] = React.useState();
    const [firstNameInvalid, setFirstNameInvalid] = React.useState(false);
    const [lastName, setLastName] = React.useState();
    const [lastNameInvalid, setLastNameInvalid] = React.useState(false);
    const [currentFile, setCurrentFile] = React.useState(undefined);
    const [progress, setProgress] = React.useState(0);
    const [image, setImage] = React.useState();
    const [password, setPassword] = React.useState();
    const [passwordInvalid, setPasswordInvalid] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [newpassword, setNewpassword] = React.useState();
    const [newpasswordInvalid, setNewpasswordInvalid] = React.useState(false);
    const [showNewpassword, setShowNewpassword] = React.useState(false);
    const [confirmpassword, setConfirmpassword] = React.useState();
    const [confirmpasswordInvalid, setConfirmpasswordInvalid] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

    const typingTimeoutRef = useRef(null);
    const selectedFilesRef = React.useRef(undefined);
    const inputFileFieldRef = React.useRef(null);

    const handleOnChangeFirstName = (e) => {
        if(typingTimeoutRef.current){
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(()=>{
            setFirstName(e.target.value);
            setFirstNameInvalid(!ValidatePersonName(e.target.value));
        },500)
    }

    const handleOnChangeLastName = (e) => {
        if(typingTimeoutRef.current){
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(()=>{
            setLastName(e.target.value);
            setLastNameInvalid(!ValidatePersonName(e.target.value));
        },500)
    }

    const isChanged = () => {
        if(
            firstName !== UserInfor.firstName ||
            lastName !== UserInfor.lastName
        ) return true;
        return false;
    }

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    };

    const onClickSaveInfor = () => {
        let event;
        if(
            firstName &&
            lastName &&
            !firstNameInvalid && 
            !lastNameInvalid
        ) {
            setLoading(true);
            event = EditAccountInfor(
                firstName
                ,lastName
            );
        }
        event?.then(res => {
            // localStorage.setItem('token', res?.data?.token);
            localStorage.setItem('_userinfor', JSON.stringify({ ...UserInfor, firstName: firstName, lastName: lastName }));
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                props.dispatch({ type: 'UPDATE_USER_INFOR', UserInfor: { ...UserInfor, firstName: firstName, lastName: lastName } });
                setLoading(false);
            }, 1000);
        })
        .catch(err => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
            setLoading(false);
        })
    };

    const onClickCancelInfor = () => {
        setFirstNameInvalid(false);
        setLastNameInvalid(false);
        document.getElementById('firstname').value = UserInfor.firstName;
        document.getElementById('lastname').value = UserInfor.lastName;
        setFirstName(UserInfor.firstName);
        setLastName(UserInfor.lastName);
    };

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const handleOnChangePassword = (e) => {
        if(typingTimeoutRef.current){
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(()=>{
            setPassword(e.target.value);
            setPasswordInvalid(!ValidatePassword(e.target.value));
        },500)
    }
    const handleOnChangeNewpassword = (e) => {
        if(typingTimeoutRef.current){
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(()=>{
            setNewpassword(e.target.value);
            setNewpasswordInvalid(!ValidatePassword(e.target.value));
        },500)
    }
    const handleOnChangeConfirmpassword = (e) => {
        if(typingTimeoutRef.current){
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(()=>{
            setConfirmpassword(e.target.value);
            setConfirmpasswordInvalid(!ValidatePassword(e.target.value));
        },500)
    }

    const onClickSavePassword = (e) =>  {
        e.preventDefault();
        let event;
        if(!password) setPasswordInvalid(true);
        if(!newpassword) setNewpasswordInvalid(true);
        if(!confirmpassword) setConfirmpasswordInvalid(true);
        if(
            password &&
            newpassword &&
            confirmpassword &&
            !passwordInvalid &&
            !newpasswordInvalid &&
            !confirmpasswordInvalid
        ) {
            if (newpassword !== confirmpassword) {
                setTimeout(() => {
                    props.dispatch({ 
                        type: 'UPDATE_SNACKBARALERT', 
                        SnackbarAlert: {
                            open: true,
                            severity: 'error',
                            message: translate('passwordisnotmatch'),
                            handleClose: () => handleCloseSnackbarAlert()
                        } 
                    });
                }, 1000)
            } else {
                setLoading(true);
                event = ChangePassword(password, newpassword, confirmpassword);
            }
        }
        event?.then(res => {
            // localStorage.setItem('token', res?.data?.token);
            setLoading(false);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                document.getElementById('password').value = "";
                document.getElementById('new-password').value = "";
                document.getElementById('confirm-password').value = "";
                setPassword("");
                setNewpassword("");
                setConfirmpassword("");
            }, 1000)
        })
        .catch(err => {
            setLoading(false);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
    }

    const selectFile = (event) => {
        selectedFilesRef.current = event.target.files;
        if (selectedFilesRef.current.length > 0) {
            upload();
        }
    };

    const upload = () => {
        let event;
        let currentFile = selectedFilesRef.current[0];
    
        setProgress(0);
        setCurrentFile(currentFile);
    
        event = UploadAvatar(currentFile, (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        });
        
        event?.then((res) => {
            // console.log(res.data)
            setImage(res?.data?.fileName);
            setProgress(0);
            setCurrentFile(undefined);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                window.location.reload();
            }, 1000);
        })
        .catch((err) => {
            setProgress(0);
            setCurrentFile(undefined);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        });
        selectedFilesRef.current = undefined;
    };

    const UploadButtons = () => (
        <>
            <input accept="image/*" id="icon-button-file" type="file" style={{"display": "none"}} ref={inputFileFieldRef} onChange={selectFile}/>
            <IconButton color="secondary" aria-label="upload picture" size="small" component="label" htmlFor="icon-button-file">
                <PhotoCamera fontSize="inherit" sx={{ color: "#fff" }} />
            </IconButton>
        </>
    )
    

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setFirstName(UserInfor.firstName);
        setLastName(UserInfor.lastName);
        GetAvatar().then(res => setImage(res?.data?.fileName));
    }, [])

    return (
        <Container maxWidth="xl">
            <Grid container spacing={3}>
                <Grid item xs={3}>
                    <Box className="profile-box">
                        <Typography variant="h6" component="div" className='title'>
                            {translate('userprofile')}
                        </Typography>
                        <List>
                            <ListItem disablePadding>
                                <ListItemButton
                                     selected={selectedIndex === 0}
                                     onClick={(event) => handleListItemClick(event, 0)}
                                >
                                    <ListItemIcon>
                                        <PersonOutlineOutlinedIcon color='secondary' />
                                    </ListItemIcon>
                                    <ListItemText primary={translate('userinfor')} />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton
                                     selected={selectedIndex === 1}
                                     onClick={(event) => handleListItemClick(event, 1)}
                                >
                                    <ListItemIcon>
                                        <HttpsOutlinedIcon color='secondary' />
                                    </ListItemIcon>
                                    <ListItemText primary={translate('password')} />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Box>
                </Grid>
                <Grid item xs={9}>
                    <Box className="profile-box">
                    {selectedIndex === 0 &&
                    (
                        <>
                            <Typography variant="subtitle1" gutterBottom component="div" className='sub-title'>
                              {translate('edityouraccountinformation')}
                            </Typography>
                            <Box sx={{ p: 3 }}>
                                <Grid container>
                                    <Grid item xs={8}>
                                        <Badge color="secondary" overlap="circular" badgeContent={<UploadButtons />}>
                                            <Avatar src={image ? `${process.env.REACT_APP_PROTOCOL}${process.env.REACT_APP_DOMAIN_NAME}/tmp/${UserInfor.userID}/profile/avatar/${image}` : ""} component="span" sx={{ bgcolor: 'secondary.main', width: 90, height: 90, borderRadius: '50%' }} />
                                        </Badge>
                                        {currentFile &&
                                        <Typography variant="caption" display="block" gutterBottom>
                                            {`${progress} %`}
                                        </Typography>}
                                    </Grid>
                                    <Grid item xs={4}>
                                        {isChanged() && <Box sx={{ display: "flex", justifyContent: "right", alignItems: "center", gap: 2, height: "100%" }}>
                                            <Button 
                                                onClick={onClickCancelInfor}
                                                color="secondary"
                                                variant="outlined"
                                                >
                                                {translate('cancel')}
                                            </Button>
                                            <LoadingButton
                                                onClick={onClickSaveInfor}
                                                endIcon={<SendIcon />}
                                                loading={loading}
                                                loadingPosition="end"
                                                variant="contained"
                                                disableElevation
                                                disabled={firstNameInvalid || lastNameInvalid}
                                                >
                                                {translate('save')}
                                            </LoadingButton>
                                        </Box>}
                                    </Grid>
                                    <Grid item xs={12} sx={{ py: 2 }}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={6}>
                                                <TextField 
                                                    fullWidth 
                                                    id="firstname" 
                                                    label={translate('firstname')} 
                                                    variant="outlined" 
                                                    defaultValue={UserInfor.firstName}
                                                    onChange={handleOnChangeFirstName}
                                                    error={firstNameInvalid}
                                                    helperText={
                                                        firstNameInvalid ? translate('pleaseenteravalidfirstname') :
                                                        ""
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField 
                                                    fullWidth 
                                                    id="lastname" 
                                                    label={translate('lastname')} 
                                                    variant="outlined" 
                                                    defaultValue={UserInfor.lastName}
                                                    onChange={handleOnChangeLastName}
                                                    error={lastNameInvalid}
                                                    helperText={
                                                        lastNameInvalid ? translate('pleaseenteravalidlastname') :
                                                        ""
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField 
                                                    fullWidth 
                                                    id="email" 
                                                    label={translate('email')} 
                                                    variant="outlined" 
                                                    value={UserInfor.email}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField 
                                                    fullWidth 
                                                    id="role" 
                                                    label={translate('role')} 
                                                    variant="outlined" 
                                                    value={UserInfor.roleID === 1 ? translate('administrator') : translate('user')}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField 
                                                    fullWidth 
                                                    id="package" 
                                                    label={translate('package')} 
                                                    variant="outlined" 
                                                    value={
                                                        parseInt(UserInfor.planID) === 0 ? translate('standard') :
                                                        parseInt(UserInfor.planID) === 1 ? translate('premium') :
                                                        parseInt(UserInfor.planID) === 2 ? translate('enterprise'):
                                                        ""
                                                    }
                                                    disabled
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </>
                    )}
                    {selectedIndex === 1 &&
                    (
                        <>
                            <Typography variant="subtitle1" gutterBottom component="div" className='sub-title'>
                              {translate('changeyourpassword')}
                            </Typography>
                            <Box sx={{ p: 3 }}>
                                <Grid>
                                    <Grid container xs={6} spacing={3}>
                                        <Grid item xs={12}>
                                            <FormControl required fullWidth variant="outlined">
                                                <OutlinedInput
                                                    id="password" 
                                                    size="small"
                                                    type={showPassword ? 'text' : 'password'}
                                                    onChange={handleOnChangePassword}
                                                    endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                        onClick={() => setShowPassword(!showPassword) }
                                                        onMouseDown={(event) =>  event.preventDefault() }
                                                        edge="end"
                                                        >
                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                    }
                                                    label=""
                                                    placeholder={translate('currentpassword')}
                                                    error={passwordInvalid}
                                                />
                                                {passwordInvalid && (
                                                <FormHelperText error id="current-password" >
                                                {translate('pleaseenteravalidpassword')}
                                                </FormHelperText>)}
                                            </FormControl>
                                            {password && <PasswordStrengthBar 
                                                password={password}
                                                scoreWords={[translate('weak'), translate('okay'), translate('good'), translate('strong'), translate('stronger')]}
                                                minLength={8}
                                                shortScoreWord={((password?.length < 8)) ? translate('tooshort') : ''}
                                            />}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl required fullWidth variant="outlined"sx={{ mb: "2px" }}>
                                                <OutlinedInput
                                                    id="new-password" 
                                                    size="small"
                                                    type={showNewpassword ? 'text' : 'password'}
                                                    onChange={handleOnChangeNewpassword}
                                                    endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                        onClick={() => setShowNewpassword(!showNewpassword) }
                                                        onMouseDown={(event) =>  event.preventDefault() }
                                                        edge="end"
                                                        >
                                                        {showNewpassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                    }
                                                    label=""
                                                    placeholder={translate('newpassword')}
                                                    error={newpasswordInvalid}
                                                />
                                                {newpasswordInvalid && (
                                                <FormHelperText error id="new-password" >
                                                {translate('pleaseenteravalidpassword')}
                                                </FormHelperText>)}
                                            </FormControl>
                                            {newpassword && <PasswordStrengthBar 
                                                password={newpassword}
                                                scoreWords={[translate('weak'), translate('okay'), translate('good'), translate('strong'), translate('stronger')]}
                                                minLength={8}
                                                shortScoreWord={((newpassword?.length < 8)) ? translate('tooshort') : ''}
                                            />}
                                            <FormControl required fullWidth variant="outlined">
                                                <OutlinedInput
                                                    id="confirm-password" 
                                                    size="small"
                                                    type={showConfirmPassword ? 'text' : 'password'}
                                                    onChange={handleOnChangeConfirmpassword}
                                                    endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                        onClick={() => setShowConfirmPassword(!showConfirmPassword) }
                                                        onMouseDown={(event) =>  event.preventDefault() }
                                                        edge="end"
                                                        >
                                                        {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                    }
                                                    label=""
                                                    placeholder={translate('confirmpassword')}
                                                    error={confirmpasswordInvalid}
                                                />
                                                {confirmpasswordInvalid && (
                                                <FormHelperText error id="confirm-password" >
                                                {translate('pleaseenteravalidpassword')}
                                                </FormHelperText>)}
                                            </FormControl>
                                            {confirmpassword && <PasswordStrengthBar 
                                                password={confirmpassword}
                                                scoreWords={[translate('weak'), translate('okay'), translate('good'), translate('strong'), translate('stronger')]}
                                                minLength={8}
                                                shortScoreWord={((confirmpassword?.length < 8)) ? translate('tooshort') : ''}
                                            />}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <LoadingButton
                                                onClick={onClickSavePassword}
                                                endIcon={<SendIcon />}
                                                loading={loading}
                                                loadingPosition="end"
                                                variant="contained"
                                                disableElevation
                                                >
                                                {translate('save')}
                                            </LoadingButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </>
                    )}
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
}
function mapStateToProps(state) {
    return {
        UserInfor: state.UserInfor,
        SnackbarAlert: state.SnackbarAlert,
    }
}
export default connect(mapStateToProps)(withTranslate(Profile));